import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { px } from "./stylesUtils"; // Theme selector that takes any argument and returns a string or number

export var cssProp = function cssProp(selector, value) {
  if (!value) {
    return undefined;
  }

  return selector(value) || value;
};
export var cssValueProp = function cssValueProp(selector, value, key) {
  if (!value) {
    return {};
  }

  var themeValue = selector(value);
  return _defineProperty({}, key, themeValue !== null ? themeValue : value);
};
export var cssValuesProp = function cssValuesProp(spaceSelector, values, key) {
  if (values === undefined) {
    return {};
  }

  var getValue = function getValue(value) {
    return value !== undefined ? px(spaceSelector(value) || value) : undefined;
  };

  if (typeof values === 'number' || typeof values === 'string') {
    return _defineProperty({}, key, getValue(values));
  }

  if (Array.isArray(values)) {
    if (values.length === 0) {
      return {};
    }

    return _defineProperty({}, key, values.map(getValue).join(' '));
  }

  if (_typeof(values) === 'object') {
    var _ref4;

    return _ref4 = {}, _defineProperty(_ref4, "".concat(key, "Top"), getValue(values.top)), _defineProperty(_ref4, "".concat(key, "Right"), getValue(values.right)), _defineProperty(_ref4, "".concat(key, "Bottom"), getValue(values.bottom)), _defineProperty(_ref4, "".concat(key, "Left"), getValue(values.left)), _ref4;
  }

  return {};
};